export default class GiftCertificate2 {
    constructor() {
        this.el = $(".giftCertificate2");
        if (!this.el.length) {
            return false;
        }
        this.btnAmount = this.el.find('.btnAmount');
        this.btnResetAmount = this.el.find('.btnResetAmount');
        this.btnDecQuantity = this.el.find('.btnDecQuantity');
        this.btnIncQuantity = this.el.find('.btnIncQuantity');
        this.btnSubmit = this.el.find('.btnSubmit');
        this.totalAmount = this.el.find('.totalAmount');
        this.amount = this.el.find('#Amount');
        this.quantity = this.el.find('#Quantity');
        this.message = this.el.find('#Message');
        this.messageLength = this.el.find('.messageLength');
        this.messageMaxlength = this.el.find('.messageMaxlength');

        this.update = this.update.bind(this);
        this.updateAmount = this.updateAmount.bind(this);
        this.resetAmount = this.resetAmount.bind(this);
        this.decreaseQuantity = this.decreaseQuantity.bind(this);
        this.increaseQuantity = this.increaseQuantity.bind(this);
        this.updateMessageCount = this.updateMessageCount.bind(this);
        this.updateTotalAmount = this.updateTotalAmount.bind(this);
        this.valid = this.valid.bind(this);

        this.btnAmount.on('click', this.updateAmount);
        this.btnResetAmount.on('click', this.resetAmount);
        this.btnDecQuantity.on('click', this.decreaseQuantity);
        this.btnIncQuantity.on('click', this.increaseQuantity);
        this.btnSubmit.on('click', this.valid);
        this.amount.on('input', this.update);
        this.quantity.on('input', this.update);
        this.message.on('input', this.updateMessageCount);

        this.updateTotalAmount();
        this.updateMessageCount();
        this.messageMaxlength.html(this.message.attr("maxlength"));

        this.previewShow = this.previewShow(this);
    }

    update() {
        if (this.valid()) {
            this.btnSubmit.prop('disabled', false);
        } else {
            this.btnSubmit.prop('disabled', true);
        }

        this.updateTotalAmount();
    }

    updateAmount(e) {
        this.amount.val(+this.amount.val() + +e.target.dataset.value);
        this.update();
    }

    resetAmount() {
        this.amount.val(0);
        this.update();
    }

    decreaseQuantity() {
        if (this.quantity.val() > 1) {
            this.quantity.val(+this.quantity.val() - 1);
            this.update();
        }
    }

    increaseQuantity() {
        this.quantity.val(+this.quantity.val() + 1);
        this.update();
    }

    updateMessageCount() {
        this.messageLength.html(this.message.val().length);
    }

    updateTotalAmount() {
        this.totalAmount.html(+this.amount.val() * +this.quantity.val());
    }

    valid() {
        return this.amount.val() > 0 && this.quantity.val() > 0;
    }

    previewShow() {
        if ($("#giftcertificateModal").hasClass("jsPopulate")) {

            $('#giftcertificateModal').on('shown.bs.modal', function () {
                $("#GCMessage").text($('textarea#Message').val());
                $("#GCamount").text($('#Amount').val());
                
            })
        }
        else {
            $("#giftcertificateModal").modal('show');

        }
    }

}